var LimitedStringSet = /** @class */ (function () {
    function LimitedStringSet(maxSize) {
        if (maxSize === void 0) { maxSize = 100; }
        this._size = 0;
        this.data = {};
        this.maxSize = maxSize;
    }
    LimitedStringSet.prototype.add = function (value) {
        if (this.has(value)) {
            return;
        }
        if (this.length >= this.maxSize) {
            this.removeFirst();
        }
        this.data[value] = true;
        this._size += 1;
    };
    LimitedStringSet.prototype.remove = function (value) {
        if (this.data[value]) {
            delete this.data[value];
            this._size -= 1;
        }
    };
    LimitedStringSet.prototype.removeFirst = function () {
        for (var value in this.data) {
            // eslint-disable-next-line no-prototype-builtins
            if (this.data.hasOwnProperty(value)) {
                delete this.data[value];
                this._size -= 1;
                break;
            }
        }
    };
    LimitedStringSet.prototype.has = function (value) {
        return Boolean(this.data[value]);
    };
    Object.defineProperty(LimitedStringSet.prototype, "length", {
        get: function () {
            return this._size;
        },
        enumerable: false,
        configurable: true
    });
    return LimitedStringSet;
}());

export { LimitedStringSet };
